import { FC, useEffect, useState } from "react";
import { FormInsuredOfficerPropsWrapper } from "./TypesInsuredOfficers";
import { SelectOptions } from "../../../../dtos/select-options";
import { useApiGet } from "../../../../hooks";
import { isAPITotallyComplete } from "../../../../utilities/apiFunctions";
import FormInsuredOfficer from "./FormInsuredOfficer";

const FormInsuredOfficerWrapper: FC<FormInsuredOfficerPropsWrapper> = ({
  officer,
  setOfficer,
  errors,
  insuredInformationApiPath,
}) => {
  const [officerTypes, setOfficerTypes] = useState<Partial<SelectOptions>[]>(
    []
  );

  const { dispatchGet, responseGet } = useApiGet<Partial<SelectOptions>[]>(
    `${insuredInformationApiPath}/GetInsuredInformationOfficerTypes`
  );

  useEffect(() => {
    dispatchGet();
  }, []);

  useEffect(() => {
    if (isAPITotallyComplete(responseGet)) {
      setOfficerTypes(responseGet.responseData ?? []);
    }
  }, [responseGet]);

  return (
    <FormInsuredOfficer
      officer={officer}
      setOfficer={setOfficer}
      errors={errors}
      officerTypes={officerTypes ?? []}
    />
  );
};

export default FormInsuredOfficerWrapper;
